var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventMenuShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.33301C14 5.43757 13.1046 6.33301 12 6.33301C10.8954 6.33301 10 5.43757 10 4.33301C10 3.22844 10.8954 2.33301 12 2.33301C13.1046 2.33301 14 3.22844 14 4.33301Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 9.1046 5.10457 10 4 10C2.89543 10 2 9.1046 2 8C2 6.8954 2.89543 6 4 6C5.10457 6 6 6.8954 6 8Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.667C14 12.7716 13.1046 13.667 12 13.667C10.8954 13.667 10 12.7716 10 11.667C10 10.5624 10.8954 9.66699 12 9.66699C13.1046 9.66699 14 10.5624 14 11.667Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81909 7.16666L10.1524 5.16699M5.81909 8.83366L10.1524 10.8333",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMenuShare);
export default __webpack_public_path__ + "static/media/event_menu_share.7285b0dc8d64d9a87ac519a3634ef0e8.svg";
export { ForwardRef as ReactComponent };